import React from "react";
import ShineHero from "../../components/brands/Shine/ShineHero";
import BrandPhilosophy from "../../components/brands/Shine/BrandPhilosophy";
import ProductCategories from "../../components/brands/Shine/ProductCategories";
import ProductSpotlight from "../../components/brands/Shine/ProductSpotLight";
import WhyChooseShine from "../../components/brands/Shine/WhyChooseShine";
import FormulaSpotlight from "../../components/brands/Shine/FormulaSpotLight";
import FaqCta from "../../components/brands/Shine/FaqCta";
import CtaBand from "../../components/brands/Shine/CtaBand";
import BestSellers from "../../components/brands/Shine/BestSellers";
import OtherBrands from "../../components/brands/Shine/OtherBrands";
import CmsPageHero from "../../components/CmsPageHero";

const ShinePage = () => (
  <>
    <CmsPageHero slug="shine"><ShineHero /></CmsPageHero>
    <BrandPhilosophy />
    <ProductCategories />
    <ProductSpotlight/>
    <WhyChooseShine/>
    <FormulaSpotlight/>
    <FaqCta/>
    <CtaBand/>
    <BestSellers/>
    <OtherBrands/>

  </>
);

export default ShinePage;
